import React from "react";
import InvitationDetails from "./invitationdetails";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  invitation: server.dto.Invitation
}

const InvitationAlreadyAccepted = (props: Props) => {
  const sigInUrl = `${routes.account_SignIn().absolute}?returnurl=${encodeURIComponent(props.invitation.paths.landingAbsolute)}`;

  return <div className="s1_main-panel medium">

    <InvitationDetails invitation={props.invitation} />

    <div className="ui message red">
      {props.invitation.status.message}
    </div>

    <div className="borders padding-large" style={{ textAlign: "center" }}>
      <div className="margin-bottom">
        <h3>{RESX.Invitation.ThatsMe}</h3>
      </div>
      <div>
        <a
          href={sigInUrl}
          className="button-new primary fluid">
          {RESX.GeneralLabels.SignIn}
        </a>
      </div>
    </div>

    <div className="borders padding-large" style={{ textAlign: "center" }}>
      <div className="margin-bottom">
        <h3>{RESX.Invitation.ThatsNotMe}</h3>
      </div>
      <div>
        <a
          href={`${site.promoSiteUrl}/support/article/${serverReference.supportArticleIds.invitationAcceptedBySomeoneElse}`}
          target="_blank"
          rel="noreferrer"
          className="button-new secondary fluid">
          {RESX.Invitation.HowToGetInvited}
        </a>
      </div>
    </div>

  </div>;
};

export default InvitationAlreadyAccepted;